import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingSpinner = (props) => (
    <div className={classnames('loading-spinner', props.align)}>
        <CircularProgress color={props.color} size={props.size} />
    </div>
);

LoadingSpinner.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
    align: PropTypes.string,
};

LoadingSpinner.defaultProps = {
    color: 'primary',
    size: 30,
    align: '',
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/features/Layout/components/LoadingSpinner.js